var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.75 3H13.25C13.3881 3 13.5 3.11193 13.5 3.25V13.75C13.5 13.8881 13.3881 14 13.25 14H2.75C2.61193 14 2.5 13.8881 2.5 13.75V3.25C2.5 3.11193 2.61193 3 2.75 3Z",
    fill: "#878789",
    stroke: "#5F6167",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.75H2.75C2.47386 2.75 2.25 2.97386 2.25 3.25V13.75C2.25 14.0261 2.47386 14.25 2.75 14.25H13.25C13.5261 14.25 13.75 14.0261 13.75 13.75V3.25C13.75 2.97386 13.5261 2.75 13.25 2.75Z",
    stroke: "#5F6167",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V11.5",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5V11.5",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.25C7.5 8.78587 7.68437 8.34075 8.01256 8.01256C8.34075 7.68437 8.78587 7.5 9.25 7.5C9.71413 7.5 10.1592 7.68437 10.4874 8.01256C10.8156 8.34075 11 8.78587 11 9.25V11.5",
    stroke: "#878789",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.25C5.91421 6.25 6.25 5.91421 6.25 5.5C6.25 5.08579 5.91421 4.75 5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5C4.75 5.91421 5.08579 6.25 5.5 6.25Z",
    fill: "#878789"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinp);
export default __webpack_public_path__ + "static/media/linp.c31fbfc7ca5aa38fad50cc96ea3f1dd2.svg";
export { ForwardRef as ReactComponent };